import { ReactText } from 'react'
import { SnackbarProvider as NotistackProvider, useSnackbar } from 'notistack'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import IconButton from '@mui/material/IconButton'

import { WithChild } from 'utils'

const CloseButton = ({ id }: { id: ReactText }) => {
  const { closeSnackbar } = useSnackbar()
  return (
    <IconButton onClick={() => closeSnackbar(id)}>
      <CloseRoundedIcon />
    </IconButton>
  )
}

const SnackbarProvider = ({ children }: WithChild) => (
  <NotistackProvider
    maxSnack={3}
    preventDuplicate
    dense
    action={key => <CloseButton key={key} id={key} />}
  >
    {children}
  </NotistackProvider>
)

export default SnackbarProvider
